// extracted by mini-css-extract-plugin
export default {"container":"TpCHEg","detailValueWithContext":"dkyoR2"};